import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExchangeRatesModel } from './types'

interface ExchangeRatesState {
  rates: ExchangeRatesModel[] | null
  loading: boolean
  error: string | null
}

const initialState: ExchangeRatesState = {
  rates: null,
  loading: false,
  error: null,
}

const ratesSlice = createSlice({
  name: 'rates',
  initialState,
  reducers: {
    fetchRatesStart: (state) => {
      state.loading = true
      state.error = null
    },
    fetchRatesSuccess: (state, action: PayloadAction<ExchangeRatesModel[]>) => {
      state.rates = action.payload
      state.loading = false
    },
    fetchRatesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const { fetchRatesStart, fetchRatesSuccess, fetchRatesFailure } = ratesSlice.actions
export default ratesSlice.reducer
